import { Directive, Input } from '@angular/core';

@Directive()
export abstract class ChipBaseComponent {
  @Input() text: string;
}
